import { render } from "./AboutUsContentTwo.vue?vue&type=template&id=638d1e8a"
import script from "./AboutUsContentTwo.vue?vue&type=script&lang=js"
export * from "./AboutUsContentTwo.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tre/tre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__